// ISO 4217 currency codes the currency input supports. Add a code here and to `currencyConfig`.

export const CurrencyCode = {
  USD: 'USD'
} as const satisfies Record<string, string>

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode]
